import { render, staticRenderFns } from "./ChildLoginPage.vue?vue&type=template&id=5b9510c7&"
import script from "./ChildLoginPage.vue?vue&type=script&lang=js&"
export * from "./ChildLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports